var _a, _b, _c;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { ExportPaperRepository } from '../export-paper-repository';
import { FolderSettingService } from '@/domains/detail/folder/types/folder-setting-service.interface';
import { PageSelectorServiceSymbol } from '@/presentation/components/page-selector/PageSelectorService';
import { DetailServiceSymbol } from '@/services/DetailService';
import { isPsHttpError } from '@patsnap/tahiti-core';
import { I18nService } from '@/services/i18n-service';
import { ANALYTICS_URI, OPENAPI_URI } from '@workspace/shared/constants/envConfig';
import { ToastWarning } from '@/infrastructure/utils/toast-warning';
const REACH_DAY_LIMIT_CODE = 11160016;
const REACH_YEAR_LIMIT_CODE = 11160038;
let ExportPaperServiceImpl = class ExportPaperServiceImpl {
    // eslint-disable-next-line max-params
    constructor(_exportPaperRepository, _pageSelectorService, _folderSettingService, _detailService, _i18nService) {
        this._exportPaperRepository = _exportPaperRepository;
        this._pageSelectorService = _pageSelectorService;
        this._folderSettingService = _folderSettingService;
        this._detailService = _detailService;
        this._i18nService = _i18nService;
    }
    async exportPapers(options) {
        const task = this._getExportPaperTask();
        try {
            const taskId = await this._exportPaperRepository.exportPapers(task, options);
            return taskId;
        }
        catch (error) {
            if (isPsHttpError(error)) {
                const data = error.cause;
                const code = data.error_code;
                const quotaLink = `${ANALYTICS_URI}/my/quota`;
                if (code === REACH_DAY_LIMIT_CODE) {
                    const message = this._i18nService.t('commonStatusCode.11160016', {
                        url: OPENAPI_URI,
                        quotaLink: quotaLink,
                    }).replace('href="/my/quota"', `href="${quotaLink}"`);
                    throw new ToastWarning(message);
                }
                if (code === REACH_YEAR_LIMIT_CODE) {
                    const resourceStr = this._i18nService.t('dataType.paper');
                    throw new ToastWarning(this._i18nService.t('commonStatusCode.11160038', {
                        type: resourceStr,
                        dataLink: OPENAPI_URI,
                        quotaLink: quotaLink,
                    }));
                }
            }
            throw error;
        }
    }
    _getExportPaperTask() {
        return {
            folderId: this._detailService.folderId,
            selectMode: this._pageSelectorService.mode,
            start: this._pageSelectorService.rangeFrom,
            end: this._pageSelectorService.rangeTo,
            sort: this._folderSettingService.folderSetting.current_sort,
            docIds: this._pageSelectorService.finalIds,
            filters: this._getRefiner(),
        };
    }
    _getRefiner() {
        return {
            q: this._detailService.filterInfo.q || undefined,
            efq: this._detailService.filterInfo.efq || undefined,
        };
    }
};
ExportPaperServiceImpl = __decorate([
    injectable(),
    __param(0, inject(ExportPaperRepository)),
    __param(1, inject(PageSelectorServiceSymbol)),
    __param(2, inject(FolderSettingService)),
    __param(3, inject(DetailServiceSymbol)),
    __param(4, inject(I18nService)),
    __metadata("design:paramtypes", [typeof (_a = typeof ExportPaperRepository !== "undefined" && ExportPaperRepository) === "function" ? _a : Object, Object, typeof (_b = typeof FolderSettingService !== "undefined" && FolderSettingService) === "function" ? _b : Object, Object, typeof (_c = typeof I18nService !== "undefined" && I18nService) === "function" ? _c : Object])
], ExportPaperServiceImpl);
export { ExportPaperServiceImpl };
